<template>
  <div>
    <el-card v-bind="$attrs" class="w-full rounded-2xl p-1">
      <slot />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'OCard',
  inheritAttrs: false
}
</script>

<style scoped></style>
